import { useEffect, useState } from "react";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";

function AdminProtect({ children }) {
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        window.location.href = "/login";
        return;
      }

      try {
        const token = await user.getIdTokenResult();

        if (token.claims.admin) {
          setAllowed(true);
        } else {
          alert("❌ Access Denied");
          await auth.signOut();
          window.location.href = "/login";
        }
      } catch (e) {
        console.error(e);
        window.location.href = "/login";
      }

      setLoading(false);
    });

    return () => unsub();
  }, []);

  if (loading) {
    return (
      <div style={{ color: "white", padding: 20 }}>
        Checking access...
      </div>
    );
  }

  return allowed ? children : null;
}

export default AdminProtect;